import numeral from "numeral";
import moment from "moment";
import _ from "lodash";

const NULL_FIELD = "--";

export function formatDisplayValue(data) {
  if (data) {
    return data;
  }

  return "--";
}
export function formatCurrency(data) {
  const val = data;
  if (val === null) {
    return "--";
  }
  const roundedVal = val.toFixed(0);
  if (Math.abs(roundedVal) < 100000) {
    return `${numeral(roundedVal).format("$0,0a")}`;
  }
  // if less than 1 million, format is without decimals
  if (Math.abs(roundedVal) < 1000000) {
    return `${numeral(roundedVal).format("($0,0a)")}`;
  }
  // if 1 million or above, format is always with two decimals
  if (Math.abs(roundedVal) >= 1000000) {
    return `${numeral(roundedVal)
      .format("($0,0.00a)")
      .toUpperCase()}`;
  }
}
export function formatCurrencyWithRounding(data) {
  const val = data;
  if (val === null) {
    return "__";
  }

  return numeral(val).format("$0,0");
}
export function formatPrepayment(data) {
  if (data.hasLockout) {
    return "LOCKOUT";
  }

  return formatCurrency(data.val);
}
export function formatCurrencyTwoDecimal(data) {
  const val = data;
  if (val === null) {
    return "--";
  }
  if (Math.abs(val) < 100000) {
    return `${numeral(val).format("($0,0.00)")}`;
  }
  // if less than 1 million, format is without decimals
  if (Math.abs(val) < 1000000) {
    return `${numeral(val).format("($0,0.00a)")}`;
  }
  // if 1 million or above, format is always with two decimals
  if (Math.abs(val) >= 1000000) {
    return `${numeral(val)
      .format("($0,0.00a)")
      .toUpperCase()}`;
  }
}
export function formatRate(data) {
  if (data !== null) {
    return numeral(data).format("0.00%");
  }

  return "--";
}
export function formatDscr(data) {
  const dscrValue = data;
  if (dscrValue !== null) {
    return `${numeral(data).format("0.00")}x`;
  }

  return "--";
}
export function formatRateThreeDecimal(data) {
  if (data !== null) {
    return numeral(data).format("0.000%");
  }

  return "--";
}
export function formatDecimalAsInteger(data) {
  if (data !== null) {
    return numeral(data).format("0,0");
  }

  return "--";
}
export function formatInteger(data) {
  if (data !== null) {
    return numeral(data).format("0,0");
  }

  return "--";
}
export function formatMonths(data) {
  if (data !== null) {
    return data;
  }

  return "--";
}

export function formatDaysToYears(data) {
  if (data !== null) {
    return moment.duration(data, "days").as("years");
  }

  return "--";
}

export function formatDate(data) {
  if (data !== null) {
    return moment.utc(data).format("MM/DD/YYYY");
  }

  return "--";
}
export function formatNumberOneDecimal(data) {
  if (data !== null) {
    return numeral(data).format("0,0.0");
  }

  return "--";
}
export function formatNumberTwoDecimal(data) {
  if (data !== null) {
    return numeral(data).format("0,0.00");
  }

  return "--";
}
export function formatNumberTwoDecimalWithRounding(data) {
  const val = data;
  if (val === null) {
    return "--";
  }
  // if less than 1 million, format is without decimals
  if (Math.abs(val) < 1000000) {
    return `${numeral(val).format("(0,0a)")}`;
  }
  // if 1 million or above, format is always with two decimals
  if (Math.abs(val) >= 1000000) {
    return `${numeral(val)
      .format("(0,0.00a)")
      .toUpperCase()}`;
  }
}
export function formatDecimalNoDecimal(data) {
  if (data !== null) {
    return numeral(data).format("0,0");
  }

  return "--";
}
export function notImplemented(data) {
  return "--";
}

// metric specific formatters
export function formatPrepaymentPenalty(data) {
  if (data) {
    return data;
  }

  return formatCurrency(data);
}

export function formatExtensionsQualification(data) {
  if (data !== null) {
    return data ? "QUALIFIED" : "NOT QUALIFIED";
  }

  return NULL_FIELD;
}
